"use strict";
/*
 *
 * Gère tous les toggleButton
 * On donne un élément HMTL en paramètre + options (facultatif)
 * Sélectionne le button et toggle la classe
 * Ajout de fonctions en options "off", "on" pour faire un callback au moment où on clique sur off ou on
 *
 * */
class ToggleButton {
    constructor(selector, options) {
        this.selector = "";
        this.formats = [];
        this.activeClassName = "-active";
        this.options = {
            off: () => { },
            on: () => { }
        };
        this.init(selector, options);
    }
    init(selector, options) {
        if (options) {
            this.options = Object.assign(Object.assign({}, this.options), options);
        }
        // cherche les éléments du DOM
        let element = null;
        if (typeof (selector) == typeof (HTMLElement)) {
            element = selector;
        }
        else if (selector && selector != "") {
            element = document.querySelector(selector);
        }
        this.DOM = {
            button: element,
        };
        this.addEvents();
    }
    off() {
        if (this.DOM.button.classList.contains(this.activeClassName)) {
            this.DOM.button.classList.remove(this.activeClassName);
            if (this.options.off) {
                this.options.off = this.options.off.bind(this);
                this.options.off();
            }
        }
    }
    on() {
        if (!this.DOM.button.classList.contains(this.activeClassName)) {
            this.DOM.button.classList.add(this.activeClassName);
            if (this.options.on) {
                this.options.on = this.options.on.bind(this);
                this.options.on();
            }
        }
    }
    addEvents() {
        if (!this.DOM.button)
            return;
        this.DOM.button.addEventListener("click", (e) => {
            if (this.DOM.button.classList.contains(this.activeClassName)) {
                this.off();
            }
            else {
                this.on();
            }
        });
    }
}
;
//# sourceMappingURL=maty.toggleButton.js.map